/* JW SHOP — Viewer 3D roue (WebGL pur, zéro dépendance)
   API :
     var v = JW3D.init(containerEl, meshData);
     v.setColors({jante:'#1a1a1a', moyeu:'#c9ced2', rayons:'#c9ced2', tetes:'#c9ced2', pneu:'#232323'});
     v.setTireVisible(true|false);
     v.supported  // false si WebGL indisponible → l'appelant garde le SVG
     v.destroy();
   meshData : {parts:[{group:'jante'|'moyeu'|'rayons'|'tetes'|'pneu', positions:[..], normals:[..], indices:[..]}]}
*/
(function(){
  'use strict';
  /* Éclairage type studio (image-based lite, espace vue = matcap) :
     - dôme procédural échantillonné en diffus (normale) et spéculaire (réflexion)
     - métalness (anodisé = métal, teinte la réflexion) vs powder coat (mat, diffus)
     - Fresnel sur les bords → sensation d'anodisation brillante */
  var VS = [
    'attribute vec3 aPos; attribute vec3 aNrm;',
    'uniform mat4 uMV; uniform mat4 uProj;',
    'varying vec3 vN; varying vec3 vP;',
    'void main(){',
    '  vec4 p = uMV * vec4(aPos,1.0);',
    '  vP = p.xyz;',
    '  vN = mat3(uMV[0].xyz, uMV[1].xyz, uMV[2].xyz) * aNrm;',
    '  gl_Position = uProj * p;',
    '}'
  ].join('\n');
  var FS = [
    'precision highp float;',
    'varying vec3 vN; varying vec3 vP;',
    'uniform vec3 uColor; uniform float uMetal; uniform float uRough; uniform float uFuel;',
    'vec3 envMap(vec3 r){',
    '  float up = clamp(r.y*0.5+0.5, 0.0, 1.0);',
    '  vec3 grd=vec3(0.13,0.13,0.15), hor=vec3(0.48,0.50,0.55), sky=vec3(0.97,0.99,1.02);',
    '  vec3 c = up>0.5 ? mix(hor,sky,(up-0.5)*2.0) : mix(grd,hor,up*2.0);',
    '  vec3 key = normalize(vec3(0.35,0.85,0.45));',
    '  c += vec3(1.15)*pow(max(dot(normalize(r),key),0.0), 60.0);',        // spot principal net
    '  c += vec3(0.55)*pow(max(dot(normalize(r),key),0.0), 6.0);',         // halo doux
    '  vec3 rim = normalize(vec3(-0.6,0.25,0.55));',
    '  c += vec3(0.4)*pow(max(dot(normalize(r),rim),0.0), 10.0);',         // 2e source
    '  return c;',
    '}',
    'void main(){',
    '  vec3 N = normalize(vN);',
    '  vec3 V = normalize(-vP);',
    '  float NdotV = max(dot(N,V), 0.0);',
    '  vec3 R = reflect(-V, N);',
    '  float gloss = 1.0 - uRough;',
    '  vec3 C = uColor;',
    '  if(uFuel>0.5){',                                                     // oil-slick / neochrome : teinte iridescente selon l\'angle
    '    float a = NdotV*1.7 + R.y*0.6 + R.x*0.25;',
    '    C = 0.52 + 0.42*cos(6.28318*(vec3(0.0,0.33,0.67) + a));',
    '  }',
    '  vec3 eDiff = envMap(N);',                                            // ambiance diffuse
    '  vec3 eSpec = mix(eDiff, envMap(R), gloss);',                         // réflexion nette si peu rugueux
    '  float F0 = mix(0.04, 1.0, uMetal);',
    '  float F = F0 + (1.0-F0)*pow(1.0-NdotV, 5.0);',
    '  vec3 diffuse  = C * eDiff * (1.0 - uMetal);',
    '  vec3 specular = eSpec * mix(vec3(1.0), C*1.25, uMetal) * F;',
    '  vec3 col = diffuse + specular;',
    '  vec3 L = normalize(vec3(0.35,0.75,0.55)); vec3 H = normalize(L+V);',
    '  col += vec3(pow(max(dot(N,H),0.0), mix(14.0,150.0,gloss))) * gloss * mix(0.35,1.1,uMetal);',
    '  gl_FragColor = vec4(pow(min(col,vec3(1.0)), vec3(0.9)), 1.0);',      // léger gamma
    '}'
  ].join('\n');

  function hex(c){ c=(c||'#888').replace('#',''); if(c.length===3) c=c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
    return [parseInt(c.substr(0,2),16)/255, parseInt(c.substr(2,2),16)/255, parseInt(c.substr(4,2),16)/255]; }

  /* --- petites matrices 4x4 --- */
  function mIdent(){ return [1,0,0,0, 0,1,0,0, 0,0,1,0, 0,0,0,1]; }
  function mMul(a,b){ var o=new Array(16);
    for(var r=0;r<4;r++)for(var c=0;c<4;c++){ var s=0; for(var k=0;k<4;k++) s+=a[k*4+c]*b[r*4+k]; o[r*4+c]=s; }
    return o; }
  function mPersp(fov,asp,n,f){ var t=1/Math.tan(fov/2);
    return [t/asp,0,0,0, 0,t,0,0, 0,0,(f+n)/(n-f),-1, 0,0,2*f*n/(n-f),0]; }
  function mTrans(x,y,z){ var m=mIdent(); m[12]=x;m[13]=y;m[14]=z; return m; }
  function mRotX(a){ var c=Math.cos(a),s=Math.sin(a); return [1,0,0,0, 0,c,s,0, 0,-s,c,0, 0,0,0,1]; }
  function mRotY(a){ var c=Math.cos(a),s=Math.sin(a); return [c,0,-s,0, 0,1,0,0, s,0,c,0, 0,0,0,1]; }

  function init(container, meshData){
    var canvas = document.createElement('canvas');
    canvas.style.cssText='width:100%;height:100%;display:block;touch-action:none;cursor:grab';
    container.innerHTML=''; container.appendChild(canvas);
    var gl = canvas.getContext('webgl', {antialias:true, alpha:true, preserveDrawingBuffer:true});
    if(!gl) return {supported:false, setColors:function(){}, setFinish:function(){}, setTireVisible:function(){}, destroy:function(){}};

    function sh(type, src){ var s=gl.createShader(type); gl.shaderSource(s,src); gl.compileShader(s); return s; }
    var prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, VS));
    gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FS));
    gl.linkProgram(prog); gl.useProgram(prog);
    var aPos=gl.getAttribLocation(prog,'aPos'), aNrm=gl.getAttribLocation(prog,'aNrm');
    var uMV=gl.getUniformLocation(prog,'uMV'), uProj=gl.getUniformLocation(prog,'uProj');
    var uColor=gl.getUniformLocation(prog,'uColor'), uMetal=gl.getUniformLocation(prog,'uMetal'), uRough=gl.getUniformLocation(prog,'uRough'), uFuel=gl.getUniformLocation(prog,'uFuel');
    gl.enable(gl.DEPTH_TEST);

    /* normalisation : centre le modèle et le met à l'échelle 1 */
    var mn=[1e9,1e9,1e9], mx=[-1e9,-1e9,-1e9];
    meshData.parts.forEach(function(p){ for(var i=0;i<p.positions.length;i+=3){
      for(var k=0;k<3;k++){ var v=p.positions[i+k]; if(v<mn[k])mn[k]=v; if(v>mx[k])mx[k]=v; } } });
    var ctr=[(mn[0]+mx[0])/2,(mn[1]+mx[1])/2,(mn[2]+mx[2])/2];
    var scale=2.0/Math.max(mx[0]-mn[0], mx[1]-mn[1], mx[2]-mn[2]);

    var parts = meshData.parts.map(function(p){
      var pos=new Float32Array(p.positions.length);
      for(var i=0;i<p.positions.length;i+=3){
        pos[i]  =(p.positions[i]  -ctr[0])*scale;
        pos[i+1]=(p.positions[i+1]-ctr[1])*scale;
        pos[i+2]=(p.positions[i+2]-ctr[2])*scale;
      }
      var vb=gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,vb); gl.bufferData(gl.ARRAY_BUFFER,pos,gl.STATIC_DRAW);
      var nb=gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,nb); gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(p.normals),gl.STATIC_DRAW);
      var ib=gl.createBuffer(); gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,ib);
      var use32 = pos.length/3 > 65535;
      gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, use32?new Uint32Array(p.indices):new Uint16Array(p.indices), gl.STATIC_DRAW);
      if(use32) gl.getExtension('OES_element_index_uint');
      return {group:p.group, vb:vb, nb:nb, ib:ib, n:p.indices.length, u32:use32};
    });

    var colors={jante:'#1a1a1a',moyeu:'#c9ced2',rayons:'#c9ced2',tetes:'#c9ced2',pneu:'#232323'};
    /* finitions par groupe : metal (0=diélectrique, 1=métal), rough (0=miroir, 1=mat) */
    var mat={ jante:{m:0.85,r:0.24}, moyeu:{m:0.82,r:0.30}, rayons:{m:0.78,r:0.34},
              tetes:{m:0.80,r:0.30}, pneu:{m:0.0,r:1.0} };
    var tireVisible=true, rotY=0.6, rotX=0.25, auto=true, destroyed=false;

    /* interactions : drag pour orbiter */
    var drag=null;
    canvas.addEventListener('pointerdown',function(e){ drag={x:e.clientX,y:e.clientY}; auto=false; canvas.setPointerCapture(e.pointerId); canvas.style.cursor='grabbing'; });
    canvas.addEventListener('pointermove',function(e){ if(!drag)return;
      rotY += (e.clientX-drag.x)*0.01; rotX += (e.clientY-drag.y)*0.01;
      rotX=Math.max(-1.4,Math.min(1.4,rotX)); drag={x:e.clientX,y:e.clientY}; });
    canvas.addEventListener('pointerup',function(){ drag=null; canvas.style.cursor='grab'; });

    function frame(){
      if(destroyed) return;
      var dpr=Math.min(window.devicePixelRatio||1,2);
      var w=container.clientWidth||300, h=container.clientHeight||300;
      if(canvas.width!==w*dpr||canvas.height!==h*dpr){ canvas.width=w*dpr; canvas.height=h*dpr; }
      gl.viewport(0,0,canvas.width,canvas.height);
      gl.clearColor(0,0,0,0); gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
      if(auto) rotY+=0.004;
      var model=mMul(mRotX(rotX), mRotY(rotY));
      var view=mTrans(0,0,-3.0);
      var mv=mMul(view, model);
      var proj=mPersp(0.72, (w/h)||1, 0.1, 30);
      gl.uniformMatrix4fv(uMV,false,new Float32Array(mv));
      gl.uniformMatrix4fv(uProj,false,new Float32Array(proj));
      parts.forEach(function(p){
        if(p.group==='pneu' && !tireVisible) return;
        var cval=colors[p.group]||'#888';
        var isFuel=(cval==='FUEL'||cval==='Fuel'||cval==='RAINBOW'||cval==='Rainbow');
        var mt=isFuel?{m:0.92,r:0.18}:(mat[p.group]||{m:0.5,r:0.5});
        gl.uniform1f(uFuel, isFuel?1.0:0.0);
        gl.uniform3fv(uColor, hex(isFuel?'#8890a0':cval));
        gl.uniform1f(uMetal, mt.m); gl.uniform1f(uRough, mt.r);
        gl.bindBuffer(gl.ARRAY_BUFFER,p.vb); gl.enableVertexAttribArray(aPos); gl.vertexAttribPointer(aPos,3,gl.FLOAT,false,0,0);
        gl.bindBuffer(gl.ARRAY_BUFFER,p.nb); gl.enableVertexAttribArray(aNrm); gl.vertexAttribPointer(aNrm,3,gl.FLOAT,false,0,0);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,p.ib);
        gl.drawElements(gl.TRIANGLES,p.n,p.u32?gl.UNSIGNED_INT:gl.UNSIGNED_SHORT,0);
      });
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    return {
      supported:true,
      setColors:function(c){ for(var k in c) if(c[k]) colors[k]=c[k]; },
      /* f: {group:{m:metal, r:rough}} — ex. jante anodisée brillante vs powder coat mate */
      setFinish:function(f){ for(var k in f){ if(!mat[k]) mat[k]={m:0.5,r:0.5};
        if(f[k].m!==undefined) mat[k].m=f[k].m; if(f[k].r!==undefined) mat[k].r=f[k].r; } },
      setTireVisible:function(v){ tireVisible=!!v; },
      destroy:function(){ destroyed=true; container.innerHTML=''; }
    };
  }
  /* Chargeur du format binaire JW3D (voir build_wheel_bin.py) :
     'JW3D' | 6×f32 (bbox min + échelle) | u16 nParts | par part : u8 groupId, u32 nVerts, u32 nIdx,
     positions 3×u16 quantisées, normales 3×i8, indices 3×u16 */
  var GROUP_NAMES=['jante','moyeu','rayons','tetes','pneu'];
  function parseBin(buf){
    var dv=new DataView(buf), o=4;
    if(String.fromCharCode(dv.getUint8(0),dv.getUint8(1),dv.getUint8(2),dv.getUint8(3))!=='JW3D') throw new Error('bad magic');
    var mn=[dv.getFloat32(o,true),dv.getFloat32(o+4,true),dv.getFloat32(o+8,true)]; o+=12;
    var sc=[dv.getFloat32(o,true),dv.getFloat32(o+4,true),dv.getFloat32(o+8,true)]; o+=12;
    var nParts=dv.getUint16(o,true); o+=2;
    var parts=[];
    for(var p=0;p<nParts;p++){
      var gid=dv.getUint8(o); o+=1;
      var nv=dv.getUint32(o,true); o+=4;
      var ni=dv.getUint32(o,true); o+=4;
      var pos=new Array(nv*3), nrm=new Array(nv*3), idx=new Array(ni);
      for(var i=0;i<nv;i++){
        pos[i*3]  = mn[0]+dv.getUint16(o,true)/65535*sc[0]; o+=2;
        pos[i*3+1]= mn[1]+dv.getUint16(o+0,true)/65535*sc[1]; o+=2;
        pos[i*3+2]= mn[2]+dv.getUint16(o,true)/65535*sc[2]; o+=2;
      }
      for(i=0;i<nv*3;i++){ nrm[i]=dv.getInt8(o)/127; o+=1; }
      for(i=0;i<ni;i++){ idx[i]=dv.getUint16(o,true); o+=2; }
      parts.push({group:GROUP_NAMES[gid]||'jante', positions:pos, normals:nrm, indices:idx});
    }
    return {parts:parts};
  }
  function load(url, cb, onerr){
    fetch(url).then(function(r){ if(!r.ok) throw new Error('HTTP '+r.status); return r.arrayBuffer(); })
      .then(function(b){ cb(parseBin(b)); })
      .catch(function(e){ if(onerr) onerr(e); });
  }
  window.JW3D = { init:init, load:load };
})();